// screens
export const ONBOARDING = 'Onboarding';
export const REP_OVERVIEW = 'RepOverview';
export const REP_DETAIL = 'RepDetail';
export const WIZARD = 'Wizard';
export const CREATE_FORECAST_WIZARD = 'CreateForecastWizard';
export const ANALYZE = 'Analyze';

// subscreens
export const QUOTAS_FOR_OWNERS = 'quotas-for-owners';
export const OWNERS_IN_TABLE = 'owners-in-table';
export const OWNERS_NOT_ASSIGNED_TEAMS = 'owners-not-assigned-teams';
export const SETUP_MODAL = 'setup-modal';
export const SETUP_COMPLETE_MODAL = 'setup-complete-modal';
export const ANALYZE_DATA_WELL = 'analyze-data-well';
export const ANALYZE_PROJECTION_TABLE = 'analyze-projection-table';
export const ANALYZE_VISUAL_REPORT = 'analyze-visual-report';
export const ANALYZE_OPT_IN = 'analyze-opt-in';
export const ANALYZE_BACKFILLING = 'analyze-backfilling';

// interactions
export const FORECASTING_INTERACTION = 'forecastingInteraction';
export const USE_FILTERS = 'useFilters';
export const ANALYZE_INTERACTION = 'analyzeInteraction';

// deal table actions
export const PREVIEW_DEAL = 'preview-deal';
export const INLINE_EDIT_DEAL_PROPERTY = 'inline-edit-deal-property';
export const DEAL_TABLE_SORT = 'deal-table-sort';
export const DEAL_TABLE_EDIT_COLUMNS_OPEN = 'deal-table-edit-columns-open';
export const DEAL_TABLE_EDIT_COLUMNS_SAVE = 'deal-table-edit-columns-save';
export const SAVE_BAR_CANCEL = 'save-bar-cancel';
export const SELECT_DEAL_FROM_DEAL_TABLE = 'select-deal-from-deal-table';
export const DESELECT_DEAL_FROM_DEAL_TABLE = 'deselect-deal-from-deal-table';
export const CLICK_SUBMIT_FORECAST_FROM_DEAL_TABLE = 'click-submit-forecast-from-deal-table';

// deals and goals sidebar actions
export const VIEW_DEALS_IN_CRM = 'view-deals-in-crm';
export const OPEN_DEAL_SIDEBAR = 'open-deal-sidebar';
export const OPEN_DEAL_SIDEBAR_FROM_DEAL_COUNT = 'open-deal-sidebar-from-deal-count';
export const OPEN_GOALS_SIDEBAR_FROM_ATTAINMENT = 'open-goals-sidebar-from-attainment';
export const VIEW_DEALS_IN_CRM_FROM_SIDEBAR = 'view-deals-in-crm-from-sidebar';
export const VIEW_GOALS_IN_CRM_FROM_SIDEBAR = 'view-goals-in-crm-from-sidebar';
export const SWITCH_TO_GOALS_SIDEBAR = 'switch-to-goals-sidebar';
export const SWITCH_TO_DEALS_SIDEBAR = 'switch-to-deals-sidebar';
export const ANALYZE_DATA_WELL_EMPTY_STATE = 'analyze-data-well-empty-state';

// submission panel actions
export const OPEN_SUBMISSION_PANEL = 'open-submission-panel';
export const OPEN_SUBMISSION_PANEL_BY_SELECTING_DEAL = 'open-submission-panel-by-selecting-deal';
export const SUBMIT_FORECAST = 'submit-forecast';
export const SUBMIT_FORECAST_FOR_ALL_PIPELINES = 'submit-forecast-for-all-pipelines';
export const OVERRIDE_SELECTED_DEAL_AMOUNT = 'override-selected-deal-amount';
export const ADD_SUBMISSION_NOTE = 'add-submission-note';
export const VIEW_SUBMISSION_PANEL_HISTORY = 'view-submission-panel-history';
export const NAVIGATE_TO_SALES_ANALYTICS = 'navigate-to-sales-analytics';
export const NAVIGATE_BACK_IN_SUBMISSION_HISTORY = 'navigate-back-in-submission-history';
export const NAVIGATE_FORWARD_IN_SUBMISSION_HISTORY = 'navigate-forward-in-submission-history';
export const CLOSE_SUBMISSION_PANEL = 'close-submission-panel';
export const OPEN_REP_DETAIL_FROM_SUBMISSION_PANEL = 'open-rep-detail-from-submission-panel';
export const VIEW_INCLUDED_DEALS_FROM_SUBMIT = 'view-included-deals-from-submit';
export const VIEW_INCLUDED_DEALS_FROM_HISTORY = 'view-included-deals-from-history';
export const OPEN_DEAL_FROM_INCLUDED_DEALS = 'open-deal-from-included-deals';
export const CLICK_DELETE_SUBMISSION = 'click-delete-submission';
export const CONFIRM_DELETE_OWN_SUBMISSION = 'confirm-delete-own-submission';
export const CONFIRM_DELETE_OTHER_SUBMISSION = 'confirm-delete-other-submission';
export const CANCEL_DELETE_SUBMISSION = 'cancel-delete-submission';
export const SHOW_DEALS_NOT_SAVED_ALERT = 'show-deals-not-saved-alert';
// navigation actions
export const DRILL_INTO_TEAM = 'drill-into-team';
export const NAVIGATE_BY_BREADCRUMB = 'navigate-by-breadcrumb';
export const OPEN_OVERVIEW_SEARCH = 'open-overview-search';
export const CLOSE_OVERVIEW_SEARCH = 'close-overview-search';
export const SELECT_OVERVIEW_SEARCH = 'select-overview-search';
export const OPEN_GOALS_FROM_ATTAINMENT = 'open-goals-from-attainment';
export const SWITCH_FORECAST_TYPES = 'switch-forecast-types';
export const SWITCH_TABS = 'switch-tabs';
export const REASSIGN_DEALS_FOR_DEACTIVATED_USER = 'reassign-deals-for-deactivated-user';
export const VIEW_FORECAST_USERS_POPOVER = 'view-forecast-users-popover';
export const OPEN_EDIT_DEFAULT_COLUMNS = 'click-edit-default-columns-link';

// action menu (top-right) actions
export const EDIT_GOALS_FROM_FORECAST = 'edit-goals-from-forecast';
export const VIEW_REPORT_FROM_FORECAST = 'view-report-from-forecast';
export const MANAGE_FORECASTS = 'manage-forecasts';
export const CREATE_GOAL_IN_APP = 'create-goal-from-forecast';
export const DISMISS_SET_CURRENCY_ALERT = 'dismiss-set-currency-alert';

// UITour actions
export const START_UI_TOUR = 'start-ui-tour';
export const NEXT_STEP_UI_TOUR = 'next-step-ui-tour';
export const CANCEL_UI_TOUR = 'cancel-ui-tour';
export const FINISH_UI_TOUR = 'finish-ui-tour';
export const SHOW_DEAL_STAGE_FORECAST_INTRO_MODAL = 'show-deal-stage-forecast-intro-modal';

// Portal Activation actions
export const CLICK_USE_DEFAULT_WELCOME_MODAL = 'click-use-default-welcome-modal';
export const CLICK_CREATE_FORECAST_WELCOME_MODAL = 'click-create-forecast-welcome-modal';
export const START_EXISTING_USER_FMO_TOUR = 'start-existing-user-fmo-tour';
export const SKIP_EXISTING_USER_FMO_TOUR = 'skip-existing-user-fmo-tour';
// Forecast Type actions
export const CLICK_CREATE_FORECAST_HEADER = 'click-create-forecast-header';
export const CLICK_CREATE_FORECAST_FILTER = 'click-create-forecast-filter';
export const SWITCH_FORECAST_TYPE = 'switch-forecast-type';
export const FORECAST_TYPE_PERMISSION_ERROR = 'forecast-type-permission-error';

// Onboarding wizard actions
export const START_ONBOARDING = 'start-onboarding';
export const NEXT_STEP_ONBOARDING = 'next-step-onboarding';
export const CANCEL_ONBOARDING = 'cancel-onboarding';
export const FINISH_ONBOARDING = 'finish-onboarding';
export const PREVIOUS_STEP_ONBOARDING = 'previous-step-onboarding';
export const CLICK_CREATE_GOAL = 'click-create-goal-onboarding';
export const DELETE_CATEGORY_ONBOARDING = 'delete-category-onboarding';
export const DELETE_IS_BLOCKED_ONBOARDING = 'delete-is-blocked-onboarding';
export const MAX_CATEGORIES_ONBOARDING = 'max-categories-onboarding';
export const RENAME_CATEGORY_ONBOARDING = 'rename-category-onboarding';
export const DISABLE_AUTOMATION_ONBOARDING = 'disable-automation-onboarding';

// Analyze actions
export const SET_ANALYZE_PIPELINE = 'set-pipeline-filter';
export const CLICK_ANALYZE_KB_LINK = 'click-analyze-kb-link';
export const CLICK_ANALYZE_OPT_IN = 'click-analyze-opt-in';
export const CLICK_ANALYZE_OPT_IN_CONFIRM = 'click-analyze-opt-in-confirm';
export const DISMISS_AI_FORECASTING_V2_ALERT = 'dismiss-ai-forecasting-v2-alert';

// Multicurrency actions
export const OPEN_MULTICURRENCY_PANEL = 'open-multicurrency-panel';
export const SET_PREFERRED_CURRENCY = 'set-preferred-currency';
export const VIEW_CURRENCIES_FROM_PANEL = 'view-currencies-from-panel';